"use client";
// @ts-strict-ignore
import { normalize } from "polished";
import { createGlobalStyle, css } from "styled-components";
import { geist } from "public/fonts/geist";
import { Colors } from "./color-palette";
import type darkAppTheme from "./dark";
import type lightAppTheme from "./light";

export type AppTheme = typeof darkAppTheme | typeof lightAppTheme;

const sharedStyles = css`
  ${normalize()}

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    p {
      margin: 0;
    }
    a {
      text-decoration: none;
    }
  }

  b,
  strong {
    font-weight: 600;
  }

  /* Hide the tracking pixels */
  img[height="1"] {
    position: absolute;
  }

  button,
  input,
  select,
  textarea,
  a {
    &:focus {
      outline-color: ${Colors.cyan};
    }
  }
  // body:not(.user-is-tabbing) button:focus,
  body:not(.user-is-tabbing) input:focus,
  body:not(.user-is-tabbing) select:focus,
  body:not(.user-is-tabbing) textarea:focus,
  body:not(.user-is-tabbing) a:focus {
    outline: none;
  }
`;
// nextjs provides a font family fallback
export const GlobalStyle = createGlobalStyle<{ theme: AppTheme }>`

  ${sharedStyles}
  body span, p, h4, h3, h2, h1 {
    font-family: ${geist.style.fontFamily} !important;
  }
  body {
    &.body-fixed{
      position: fixed;
      overflow: hidden !important;
    }
    font-family: ${geist.style.fontFamily};
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.backgroundColors.primary};
    color: ${({ theme }) => theme.textColors.primary};
    .sbdocs.sbdocs-content{
      max-width: 1070px;
    }
    .sbdocs.sbdocs-preview{
      .docs-story{
        padding-bottom: 20px;
      }
    }
    .mobileScreen {
      display: block;
    }
    .desktopScreen {
      display: none;
    }
    ${({ theme: { media } }) => media.mobileLandscape`
      .mobileScreen{
        display:none;
      }
      .desktopScreen{
        display: block;
        &.flex{
          display: flex;
        }
      }
    `};
  }
  /* clears the ‘X’ from Internet Explorer */
  input[type=search]::-ms-clear { display: none; width : 0; height: 0; }
  input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }
  /* clears the ‘X’ from Chrome */
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration { display: none; }
`;
